import React, { useState, useEffect } from "react";

/**
 * A reusable error message component that disappears after 5 seconds.
 */
const FormError = ({ message, className = "" }) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (message) {
      // 1. Show the error when a new message arrives
      setIsVisible(true);

      // 2. Set a timer to hide it after 5 seconds
      const timer = setTimeout(() => {
        setIsVisible(false);
      }, 5000);

      // 3. Cleanup the timer if the component unmounts or message changes
      return () => clearTimeout(timer);
    }
  }, [message]);

  // If there's no message or the timer finished, don't render
  if (!message || !isVisible) return null;

  return (
    <div className={`form-error ${className}`}>
      <svg
        className="error-icon"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        width="16"
        height="16"
      >
        <circle cx="12" cy="12" r="10" strokeWidth="2" />
        <line
          x1="12"
          y1="8"
          x2="12"
          y2="12"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <line
          x1="12"
          y1="16"
          x2="12.01"
          y2="16"
          strokeWidth="2"
          strokeLinecap="round"
        />
      </svg>
      <span>{message}</span>
    </div>
  );
};

export default FormError;
